import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCanvasConfetti = () =>
    wrapRetry(() =>
        import(
            /* webpackChunkName: "CanvasConfetti" */
            'canvas-confetti'
        ).then((confetti) => confetti.default),
    );
